import style from "./components/style";
import menu from "./components/menu";
import form from "./components/form";
import woocommerce from "./components/woocommerce";
import myGarage from "./components/my-garage";
import fibofilters from "./components/fibofilters";
import themeToggle from "./components/theme-toggle";
import productTabs from "./components/product-tabs";

function initHiPriorityCommon() {
	style.init();
	themeToggle.init();
}

function initLowPriorityCommon() {}

function initPage() {
	menu.init();
	woocommerce.init();
	form.init();
	myGarage.init();
	fibofilters.init();
	productTabs.init();
}

window.utils.domReady(function () {
	if (history.scrollRestoration) {
		history.scrollRestoration = "manual";
	}
	initHiPriorityCommon();
	initPage();
	initLowPriorityCommon();
});
